<template>
  <div class="payment-schedule">
    <div class="section-header">
      <v-layout row>
        <v-flex lg6>
          <div class="section-name">{{ layoutSetting.section.caption }}</div>
        </v-flex>
      </v-layout>
    </div>

    <div class="section-table">
      <table>
        <thead>
          <tr class="m-t-5">
            <th v-for="(fieldRow, index) in layoutSetting.sectionFields" :key="index">
              {{ fieldRow.label }}
            </th>
          </tr>
        </thead>
        <tbody v-if="assets.tool.isNotEmpty(dataSource.drawHistory) && dataSource.drawHistory.length > 0">
        <template v-for="(draw, i) in dataSource.drawHistory">
          <tr :key="assets.tool.getRandomKey(i)">
            <td class="text-center"
                v-for="(sectionField, j) in layoutSetting.sectionFields"
                style="color: #002B7F;"
                :key="assets.tool.getRandomKey(j)">
              {{ assets.tool.fieldRender(draw, sectionField.template, sectionField.format, sectionField.options) }}
            </td>
          </tr>
        </template>
        </tbody>
        <tbody v-else>
          <tr style="height: unset;">
            <td class="width-full text-center m-v-10">
              <i class="text-grey">No data to display</i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- end table-responsive -->
  </div>
</template>

<script>
import { PaymentApi } from '@/api/pandaria'
import { Tool } from '@/util/index'

const $tool = new Tool()

export default {
  name: 'draw-history-table',
  props: {
    layoutSetting: Object,
    loan: Object
  },
  data () {
    return {
      assets: {
        tool: $tool
      },
      dataSource: {
        drawHistory: null
      }
    }
  },
  computed: {
    loanId () {
      return this.loan.id
    }
  },
  watch: {
    loanId (val) {
      if (this.assets.tool.isNotEmpty(val)) {
        const $this = this
        PaymentApi.listDrawHistoryByParentId(val, function (result) {
          $this.dataSource.drawHistory = result
        })
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="css" scoped>
.payment-schedule {
  background: #F5F5F5;
  padding: 20px 20px 0 20px;
  margin-top: 0 !important;
}

.payment-schedule .section-header {
  margin-bottom: -15px;
  padding-top: 12px;
}

.payment-schedule .section-header .flex {
  padding: 0 12px !important;
}

.payment-schedule .section-name {
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;
  display: inline-block;
}

.payment-schedule .section-action {
  text-align: right;
  font-size: 20px;
}

.payment-schedule .section-table {
  margin-top: 10px;
}

/* section table */
.section-table {
  min-height: 180px;
  max-height: 180px;
}
.section-table table {
  table-layout: fixed;
  width: 100%;
  font-size: 14px;
}
.section-table table thead tr{
  border-bottom: solid lightgray 1px;
}
.section-table table tbody{
  display: inline-block;
  width: 100%;
  overflow: auto;
  max-height: 158px;
}
.section-table table tr{
  display: inline-block;
  width: 100%;
  height: 26px;
  line-height: 20px;
}
.section-table table td, .section-table table th {
  display: inline-block;
  width: 20%;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
}
</style>
